<div class="user-access-skin min-vh-100 d-flex flex-column linear-gradient-primary">
  <div class="mw-100 m-auto">
    <main class="bg-white mw-100 rounded">
      <div class="tab-btns-wrap d-flex">
        <a routerLink="/access/login" routerLinkActive="tab-btn--active" class="tab-btn">Login</a>
        <a routerLink="/access/register" routerLinkActive="tab-btn--active" class="tab-btn">Create Account</a>
      </div>
      <div class="px-2 py-5">
        <div class="text-center mb-5">
          <h3 class="text-uppercase" *ngIf="schoolName">{{schoolName}}</h3>
          <img *ngIf="schoollogourl" src="{{schoollogourl}}" class="logoImg" [alt]="schoolName ? schoolName + ' logo' : 'School logo'">
          <div>
            <img src="../../../assets/img/brand/delivered_through_impata.png" width="150" alt="Delivered through Impata" />
          </div>
          <p *ngIf="schoolResolved" class="text-center m-0 text-dark px-5 " style="font-size: var(--font-size-sm);">
            Impata is the online learning platform {{schoolName}} uses to host your course materials, live sessions, and assignments. Create your account now so you can access your program, preview coursework, and join your cohort as soon as sessions begin.
          </p>
          <p *ngIf="!schoolResolved" class="text-center m-0 text-dark px-5 " style="font-size: var(--font-size-sm);">
            Impata is the online learning platform your school uses to host course materials, live sessions, and assignments. Create your account now so you can access your program, preview coursework, and join your cohort as soon as sessions begin.
          </p>
        </div>
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
